// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5j-1";
export var standaloneTable = "_5j-0";